import React from 'react';
import { getKindMenuItems } from '../../../constants/planWizardTypes';

const KindChooserStep = ({ t, onSelectKind }) => {
  const items = getKindMenuItems(t);

  return (
    <div className="plan-wizard-kind-chooser">
      <p className="plan-wizard-kind-prompt">{t('plan.wizard.choose_kind')}</p>
      <div className="plan-wizard-kind-grid">
        {items.map((item) => (
          <button
            key={item.wizardType}
            type="button"
            className="plan-wizard-kind-card"
            onClick={() => onSelectKind(item.wizardType)}
          >
            <span className="plan-wizard-kind-card-title">{item.label}</span>
            <span className="plan-wizard-kind-card-description">{item.description}</span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default KindChooserStep;
